import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="header">
      <div className="header-top">
        <div className="header-top-content">
          <div className="header-contact-info">
            <span>(250) 862-1234</span>
            <span>info@sollawpartners.com</span>
          </div>
          <div>Serving Kelowna and the Okanagan Valley</div>
        </div>
      </div>
      <div className="header-main">
        <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
          <div className="logo">
            <h1>SOL LLP</h1>
            <p>Lawyers & Advocates</p>
          </div>
        </Link>
        <nav className="nav">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/team">Our Team</Link>
          <Link to="/family-law">Family Law</Link>
          <Link to="/personal-injury">Personal Injury</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;

